import React, { useEffect, useState } from 'react';
import NfdProductsLogosItemCardComponent from "./NfdProductsLogosItemCardComponent";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

interface NfdProductsLogosItemProps {
	type: 'NfdPlatform' | 'NfdCombine' | 'SomethingCool' | 'CoolDEX' | 'NfdTradingBots';
	title: string;
	purple: React.ReactElement,
	native: React.ReactElement,
	white: React.ReactElement,
	black: React.ReactElement,
}

const NfdProductsLogosItemComponent = (props: NfdProductsLogosItemProps) => {
	const [width, setWidth] = useState(window.innerWidth);
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: width < 1310 ? width < 1023 ? width < 768 ? 1 : 2 : 3 : 4,
		slidesToScroll: width < 1023 ? width < 768 ? 1 : 3 : 1,
		swipeToSlide: true,
		focusOnSelect: true,
		variableWidth: true,
		centerMode: false,
		arrows: false,
		className: "nfdProductsLogosItem_content_slider"
	};
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="nfdProductsLogosItem">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<h3>{props.title}</h3>
			<div className="nfdProductsLogosItem_content">
				<Slider {...settings}>
					<NfdProductsLogosItemCardComponent type={props.type} color={'purple'} icon={props.purple} />
					<NfdProductsLogosItemCardComponent type={props.type} color={'native'} icon={props.native} />
					<NfdProductsLogosItemCardComponent type={props.type} color={'white'} icon={props.white} />
					<NfdProductsLogosItemCardComponent type={props.type} color={'black'} icon={props.black} />
				</Slider>
			</div>
		</div>
	);
};

export default NfdProductsLogosItemComponent;